import styled from 'styled-components'

import LazyImage from '../LazyImage'

import IconBasic from './Icon/IconBasic'
import buildImageSrcset from './buildImageSrcset'

import type { FulfillingMomentName } from './types'

const Image = styled(LazyImage)`
  z-index: -2;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`

const Overlay = styled.div`
  position: absolute;
  z-index: -1;
  background-color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};
  background: linear-gradient(
    270deg,
    rgba(29, 29, 29, 0) 0%,
    rgba(29, 29, 29, 0.4) 70%,
    rgba(29, 29, 29, 0.6) 100%
  );
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
`

const Outer = styled.div`
  box-sizing: border-box;
  width: 300px;
  height: 100px;
  color: ${({ theme }) => theme?.['-ds-neutral-100']?.value};
  padding: 16px;
  position: relative;
  text-align: left;
  background-color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};
  box-shadow:
    0px 0.25px 3px rgba(0, 0, 0, 0.039),
    0px 2.75px 9px rgba(0, 0, 0, 0.19);

  border-radius: 8px;
  overflow: hidden;
  /*
    border-radius & overflow not sufficient on WebKit (i.e. Safari)
    https://bugs.webkit.org/show_bug.cgi?id=140535
  */
  z-index: 0;

  svg {
    width: 32px;
    height: 32px;
  }
`

const Name = styled.div`
  margin: 8px 0 0 0;
  font-size: 20px;
  font-weight: 400;
  text-transform: capitalize;
`

type FulfillingMomentProps = {
  momentName: FulfillingMomentName
}

const FulfillingMoment = ({ momentName }: FulfillingMomentProps) => {
  const imgSrcset = buildImageSrcset(momentName)
  return (
    <Outer>
      <IconBasic momentName={momentName} />
      <Name>{momentName}</Name>

      <Overlay />
      <Image alt={momentName} data-srcset={imgSrcset} />
    </Outer>
  )
}

export default FulfillingMoment
